import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const cityJSON = async (): Promise<any> => {
  const city = useJSONStore.getState().city;
  const token = useUserStore.getState().userToken;
  const setCity = useJSONStore.getState().setCity;

  if (city.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.city}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setCity(res.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default cityJSON;
